export const state = {
    channels: [],
};

export default state;
